import ukrainianMessages from "ra-language-ukrainian";
const shared = {
  id: "ID",
  name: "Назва",
  login: "Логін",
  created_at: "Створено",
  updated_at: "Останні зміни",
  status: "Статус",
  merchant_id: "Мерчант",
  gas_brand_id: "Заправка",
  config: "Налаштування",
  url: "Перегляд",
  mimetype: "Тип файла",
};

const uk = {
  ...ukrainianMessages,
  login: { required: "Увійдіть в кабінет" },
  buttons: {
    edit: "Редагувати",
    delete: "Видалити",
    close_editing: "Закінчити редагування",
    bulk_update_save: "Зберегти",
    bulk_update_cancel: "Скасувати",
  },
  directions: {
    center: "Центр",
    top: "По верхньому краю",
    bottom: "По нижньому краю",
    left: "Ліворуч",
    right: "Праворуч",
  },
  resizeMode: {
    cover: "Повне покриття",
    contain: "Збереження співвідношення",
    stretch: "Розтягнення",
    repeat: "Повторення",
    center: "Центр",
  },
  objectFit: {
    cover: "Повне покриття",
    contain: "Збереження співвідношення",
    fill: "Заповнення",
    scaleDown: "Зменшення маштабу",
  },
  fontStyle: {
    normal: "Звичайний",
    italic: "Курсив",
  },
  alignItems: {
    center: "По центру",
    "flex-start": "По верхньому краю",
    "flex-end": "По нижньому краю",
  },
  justifyContent: {
    center: "По центру",
    "flex-start": "Ліворуч",
    "flex-end": "Праворуч",
  },
  textAlign: {
    center: "По центру",
    start: "Ліворуч",
    end: "Праворуч",
  },
  resources: {
    Dashboard: {
      name: "Головна",
      skip: "Пропустити",
    },
    PushNotificationService: {
      notificationHeader: "Заголовок сповіщення",
      notificationMessage: "Вміст сповіщення",
      name: "Сервіси push-сповіщень",
      fields: {
        ...shared,
        config: {
          name: "Налаштування",
          app_id: "ID додатку",
          token: "Токен",
        },
      },
      source: {
        status: {
          active: "активний",
          disabled: "деактивований",
          blocked: "заблокований",
          error: "помилка",
        },
        send: "Надіслати",
        sendTitle: "Надіслати Push-сповіщення",
        selectPhoto: "Обрати зображення",
        preview: "Попередній перегляд :",
        toWhomToSend: "Кому відправити:",
        singleUser: "Один користувач",
        allUsers: "Всі користувачі",
        categories: "Категорії",
        selectUser: "Оберіть користувача",
        chooseCategory: "Оберіть категорію",
        selectTags: "Оберіть теги",
        messageSentSuccessfully: "Повідомлення успішно надіслано",
        tags: "Теги",
        errorSelectCategory: "Будь ласка, виберіть категорію",
        errorSelectTag: "Будь ласка, виберіть хоча б один тег",
        errorSelectUser: "Будь ласка, виберіть користувача",
      },
    },
    EmailService: {
      name: "Email Сервіси",
      fields: {
        ...shared,
        config: {
          name: "Налаштування",
          api_key: "АРІ ключ",
          service_id: "Сервіс ID",
          template_id: "Шаблон ID",
          user_id: "ID власника",
          accessToken: "Токен",
          api_key_public: "Публічний API ключ",
          api_key_private: "Приватний API ключ",
          token: "Токен",
          email: "Пошта",
          app_name: "Назва мобільного додатку",
          user: "Користувач",
          password: "Пароль",
        },
      },
      source: {
        status: {
          active: "активний",
          disabled: "деактивований",
          blocked: "заблокований",
          error: "помилка",
        },
      },
    },
    AsyncJob: {
      name: "Асинхронні завдання",
      fields: {
        ...shared,
        job_name: "Назва",
        next_run: "Наступний запуск",
        payload: "Деталі",
        result: "Результат",
        attempts_left: "Залишилось спроб",
        retry_delay: "Затримка повторної спроби",
      },
      source: {
        status: {
          scheduled: "заплановано",
          complete: "успішно",
          failed: "невдало",
          processing: "виконується",
        },
      },
    },
    Coupon: {
      name: "Талони",
      fields: {
        ...shared,
        id: "ID талону",
        coupon_code: "Код талону",
        fuel_type: "Тип палива",
        nominal: "Номінал",
        client_id: "Клієнт",
        trunc_id: "Транк",
        valid_period: "Строк дії",
        shared_at: "Поширений",
        reserved_until: "Зарезервований до",
        begin_date: "Термін дії: початок",
        end_date: "Термін дії: кінець",
        serial_visible: "Серійний номер",
        coupon_serial: "Серія талона",
        previous_state: "Попередній статус",
      },
      source: {
        status: {
          initial: "наявний",
          active: "активний",
          shared: "поширений",
          expired: "прострочений",
          used: "використаний",
          locked: "заблокований",
          reserved: "зарезервований",
        },
        import_file: "Бажаєте додати?",
        buttons: {
          import: "Імпортувати",
        },
      },
    },
    Total: {
      name: "Підсумки",
      fields: {
        total_sold_fuels: {
          name: "Продане паливо",
          amount_sum: "Загальна кількість проданого палива (л)",
          total_fuel_sum: "Загальна сума проданого палива (₴)",
        },
        total_topup: "Загальна сума поповнень (₴)",
        total_left_balance: "Загальна сума залишку на балансах (₴)",
        start_date: "Початок періоду",
        end_date: "Кінець періоду",
      },
    },
    QrCard: {
      name: "QR Картки",
      fields: {
        ...shared,
        card_owner: "ID власника картки",
        card_holder: "ID тримача картки",
        begin_date: "Дата створення",
        end_date: "Дата закінчення",
        card_name: "Назва картки",
        balance: "Баланс",
        phone: "Телефон тримача картки",
        pin1: "Пін-код",
        is_archive: "Статус картки",
      },
      source: {
        fn_card_owner: "ПІБ власника карти",
        card_owner: "Власник картки",
        card_holder: "Тримач картки",
        status: {
          archive: "неактивна",
          active: "активна",
        },
      },
    },
    Trunc: {
      name: "Транк",

      fields: {
        ...shared,
        merchant_payment_gateway_id: "Еквайрінг",
        client_id: "Користувач",
        description: "Призначення платежу",
        short_description: "Короткий опис призначення",
        amount: "Сума(грн)",
        transactions: "Транзакції",
        client_phone: "Телефон користувача",
        title: "Назва",
        start_date: "Початок періоду",
        end_date: "Кінець періоду",
        webhook_service_name: "Вебхук сервіс",
        payload: "Деталі",
        order_id: "ID Замовлення",
        coupon_id: "Тип палива",
        amount_nominal: "Загальна кі-сть літрів ",
        datex_id: "Датекс ID",
        session_id: "ID Сесії",
      },
      source: {
        finishPayment: "Завершити оплату",
        info: "Інформація",
        succeed: "Платіж пройшов успішно",
        webhook_service_name: {
          topupDatex: "Поповнення балансу карти Datex",
          sellCouponFromStock: "Купівля паливних талонів",
          preSellCouponFromStock: "Бронювання паливних талонів",
        },
      },
    },
    DatexTransaction: {
      name: "Транзакції",
      fields: {
        fn_card_owner: "ПІБ власника карти",
        amount: "Кількість",
        amount_ok: "Кількість",
        sum: "Сума",
        sum_ok: "Сума",
        n_account: "Тип палива",
        n_accounts_struc: "Тип палива",
        n_service_station: "Заправка",
        address: "Адреса",
        n_issuers: "Платник",
        confirm_status: "Статус",
        session_time: "Дата",
        code_edroup_card_owner: "Код ЄДРПОУ власника карти",
        serial_visible: "Серійний номер",
        is_passed: "Статус",
        card_id: "ID картки",
      },
    },
    Promotion: {
      name: "Новини",
      fields: {
        ...shared,
        file_id: "Файл",
        title: "Назва",
        text: "Текст",
        start_date: "Початок дії",
        end_date: "Кінець дії",
      },
      source: {
        status: {
          scheduled: "заплановано",
          active: "активний",
          finished: "завершено",
          blocked: "заблокований",
        },
      },
    },
    PaymentGateway: {
      name: "Платіжні шлюзи",
      fields: {
        ...shared,
      },
    },
    MerchantPaymentGateway: {
      name: "Еквайрінги",
      fields: {
        ...shared,
        id: "ID Платіжного шлюзу Мерчанта",
        payment_gateway_id: "Платіжний шлюз",
        default: "За замовчуванням",
        logo_file_id: "Логотип",
      },
    },
    Block: {
      name: "Блоки",
      fields: {
        ...shared,
        type: "Тип",
        page_id: "Сторінка",
        position: "Позиція",
        blocks: "Кількість блоків",
        container_styles: {
          backgroundColor: "Колір фону контейнера",
          alignItems: "Вертикаль",
          justifyContent: "Горизонталь",
        },
        styles: {
          textAlignVertical: "Вирівнювання тексту по вертикалі",
          textAlign: "Вирівнювання тексту",
          backgroundColor: "Колір фону",
          borderColor: "Колір обведення",
          color: "Колір тексту",
          borderWidth: "Товщина обведення",
          width: "Ширина %",
          height: "Висота %",
          borderRadius: "Радіус обведення",
          fontSize: "Розмір шрифту",
          fontWeight: "Товщина шрифту",
          alignItems: "Вирівнювання об'єктів",
          fontStyle: "Стиль шрифту",
          placeholderTextColor: "Колір тексту плейсхолдера",
          resizeMode: "Маштабування",
          objectFit: "Пропорційність об'єкта",
        },
        props: {
          text: "Текст",
          action: "Дія",
          redirect_page_id: "Посилання на кліку",
          uri: "Зображення",
          file_id: "Файл",
        },
      },
      source: {
        type: {
          Button: "Кнопка",
          EmptyBlock: "Пустий блок",
          Image: "Зображення",
          PhoneInput: "Поле для телефону",
          Text: "Текст",
          TextInput: "Текстове поле",
        },
        tab: {
          basic: "Базові налаштування",
          containerStyles: "Стилі контейнера",
          blockProps: "Налаштування блока",
        },
      },
    },
    Chat: {
      name: "Повідомлення",
      fields: {
        ...shared,
        input: {
          placeholder: "Введіть повідомлення",
        },
      },
    },
    Design: {
      name: "Дизайни",
      fields: {
        ...shared,
        default_page_id: "Сторінка по замовчуванню",
        error_page_id: "Сторінка помилки",
        authenticated_page_id: "Авторизована сторінка",
        loader_page_id: "Сторінка завантаження",
        styles: {
          backgroundColor: "Колір фону",
          color: "Колір тексту",
          justifyContent: "Горизонталь",
          alignItems: "Вертикаль",
        },
      },
    },
    Page: {
      name: "Сторінки",
      fields: {
        ...shared,
        design_id: "Дизайн",
        styles: {
          backgroundColor: "Колір фону",
          color: "Колір тексту",
          justifyContent: "Горизонталь",
          alignItems: "Вертикаль",
        },
      },
      source: {
        tab: {
          basic: "Базові налаштування",
          preview: "Попередній перегляд",
        },
      },
    },
    File: {
      name: "Файли",
      fields: {
        ...shared,
        attachments: "Вкладення",
        size: "Розмір (МБ)",
        link: "Посилання",
      },
      source: {
        mimetype: {
          "image/webp": "WEBP",
          "image/png": "PNG",
          "image/svg+xml": "SVG",
          "application/pdf": "PDF",
        },
      },
    },
    Merchant: {
      name: "Мерчант",
      fields: {
        ...shared,
        current_password: "Пароль",
        new_password: "Новий пароль",
        storage_capacity: "Об'єм файлового сховища (МБ)",
        design_id: "Дизайн",
        newbie: "Новенький",
      },
      source: {
        status: {
          active: "активний",
          inactive: "неактивний",
          disabled: "деактивований",
          blocked: "заблокований",
          error: "помилка",
        },
      },
    },
    Client: {
      name: "Користувачі",
      fields: {
        ...shared,
        phone: "Телефон",
        first_name: "Ім'я",
        last_name: "Прізвище",
        middle_name: "По-батькові",
        email: "Пошта",
        password: "Пароль",
        category_id: "Категорія",
        tag_ids: "Теги",
        city: "Місто",
        region: "Регіон",
        address: "Адреса",
        entity: "Тип користувача",
        balance: "Баланс",
        car_number: "Номер машини",
        sex: {
          name: "Стать",
          female: "Жінка",
          male: "Чоловік",
        },

        date_of_birth: "Дата народження",
        terms_agreement_confirm:
          "Підтвердження згоди з умовами публічної оферти",
        unconfirmed_changes: {
          name: "Зміни",
          field_name: "Назва поля",
          value: "Значення",
          status: "Статус",
        },
        has_changes: "Запит на зміни",
        mango_transactions: {
          fn_card_owner: "ПІБ власника карти",
          amount_ok: "Кількість",
          sum_ok: "Сума",
          n_accounts_struc: "Тип палива",
          n_service_station: "Заправка",
          address: "Адреса",
          n_issuers: "Платник",
          confirm_status: "Статус",
          session_time: "Дата",
        },
        mango_payment_transactions: {
          client_fn: "ПІБ власника карти",
          s_docums: "Сума",
          payment_note: "Призначення платежу",
          status: "Статус",
          session_time: "Дата",
        },
        mango_cards: {
          card_owner: "ПІБ власника карти",
          card_name: "Назва картки",
          phone: "Телефон користувача",
        },
        petrolcard_transactions: {
          accountName: "Тип палива",
          cardId: "ID Картки",
          serialVisible: "Cерійний номер",
          price: "Ціна(грн)",
          amount: "Кількість",
          sum: "Сума",
          politicsDiscountId: "ID політики знижок",
          discountValue: "Знижка",
          issuerName: "Назва емітента",
          versionId: "ID версії",
          transactionId: "ID транзакції",
          tradePointName: "Назва філії АЗС",
          transactionTime: "Дата і час заправки",
          tradePointAddress: "Адреса АЗС",
          passed: "Статус",
        },
        petrolcard_payment_transactions: {
          description: "Призначення платежу",
          amount: "Сума(грн)",
          transactions: "Транзакції",
          payload: "Деталі",
          order_id: "ID Замовлення",
        },
        petrolcard_cards: {
          cardId: "ID Картки",
          serialVisible: "Cерійний номер",
          isActive: "Статус",
          endDate: "Термін дії",
          cardType: "Тип картки",
          cardDiscountsConf: {
            cardDiscountsConfName: "Назва конфігурації знижок для картки",
          },
          terminalGroups: {
            name: "Термінальні групи",
            terminalGroupName: "Назва термінальної групи",
          },
          cardIssuers: {
            name: "Емітенти картки",
            cardIssuersName: "Назва емітентів картки",
          },
        },
        deleted_at: {
          title: "Видалити користувача",
          true: "Видалити",
          false: "Відновити",
        },
      },
      source: {
        status: {
          initial: "не підтверджений",
          active: "активний",
          confirmed: "підтверджений",
          disabled: "деактивований",
          blocked: "заблокований",
        },
        changes_status: {
          pending: "очікує",
          confirmed: "підтверджено",
          rejected: "відхилено",
        },
        payment_status: {
          1: "успішно",
        },
        tab: {
          basic: "Базові налаштування",
          confirm_changes: "Підтвердження змін",
        },
        infoTab: {
          info: "Інформація про користувача",
          transactions: "Транзакції",
          payment_transactions: "Поповнення",
          cards: "Картки",
        },
        entity: {
          physical: "Фізична особа",
          legal: "Юридична особа",
        },
        deleted: "Дата видалення",
        search: "Ім'я або Прізвище",
        blocked_at: "Дата блокування",
      },
    },
    SmsService: {
      name: "Смс Сервіси",
      fields: {
        ...shared,
        service_name: "Назва сервісу",
        config: {
          name: "Налаштування",
          key: "АРІ ключ",
          sender: "Відправник",
        },
        balance: "Баланс",
      },
      source: {
        status: {
          active: "активний",
          disabled: "деактивований",
          blocked: "заблокований",
          error: "помилка",
        },
      },
    },
    Category: {
      name: "Категорії",
      fields: {
        ...shared,
      },
    },
    Brand: {
      name: "Інтеграції",
      fields: {
        ...shared,
      },
      source: {
        status: {
          active: "активний",
          disabled: "деактивований",
          blocked: "заблокований",
          error: "помилка",
        },
      },
    },
    BrandMerchant: {
      name: "Інтеграції Мерчантів",
      fields: {
        ...shared,
        id: "ID Інтеграції Мерчанта",
        brand_id: "Інтеграція",
      },
      source: {
        status: {
          active: "активний",
          disabled: "деактивований",
        },
      },
    },
    GasBrandMerchant: {
      name: "Заправки Мерчантів",
      fields: {
        ...shared,
        fuels: "Паливо",
        coordinates: "Координати заправок",
        priority: "Послідовність розташування",
        logo_file_id: "Логотип",
        partner_gas_brand: "Партнер",
        qr_type: "Тип Qr-коду",
      },
      fuels: {
        name: "Тип палива",
        alias_fuel_type: "Тип палива(укр)",
        regular_price: "Ціна (в коп.)",
        discount_price: "Ціна зі знижкою (в коп.)",
        stella_price: "Середня ціна по азс (в коп.)",
        coupon_price: "Ціна онлайн талону (в коп.)",
        status: "Статус",
      },
      coordinates: {
        ...shared,
        address: "Адреса",
        lat: "Широта",
        long: "Довгота",
      },
      source: {
        status: {
          active: "активний",
          disabled: "деактивований",
          blocked: "заблокований",
        },
        no_value: "Без логотипу",
        infoTab: {
          info: "Базова інформація",
          coords: "Координати заправок",
          fuels: "Паливо",
        },
      },
    },
    Tag: {
      name: "Теги",
      fields: {
        name: "Назва",
        merchant_id: "Мерчант",
        created_at: "Створено",
        updated_at: "Останні зміни",
      },
    },
    Coordinate: {
      name: "Координати",
      fields: {
        ...shared,
        fuel_types_as_object: "Типи палива",
        address: "Адреса",
        lat: "Широта",
        long: "Довгота",
      },
    },
    notifications: {
      errors: {
        Forbidden: "Виникла помилка",
        delete_error: "Елемент не може бути видалено!",
        already_exist: "Елемент вже існує",
        name_of_fuel_already_exist: "Паливо вже існує",
        dublicate_name_of_fuel_update: "Введено однакові назви палива",
        page_set_as_default:
          "Сторінка встановлена в дизайні за замовчуванням, змініть налаштування дизайну, щоб мати можливість видалити цю сторінку",
        oversize: "Файл не може бути більше 10МВ",
        min_length: "Пароль має мати довжину не менше 4-х символів",
        max_length: "Пароль має бути меньше 10 символів",
        not_match: "Пароль невірний",
        password_required: "Пароль є обов'язковим полем",
        invalid_phone_format:
          "Невірний формат телефону, він повинен починатись з 380 та не включати в себе +",
        invalid_email_format: "Некоректний правопис електронної пошти",
        no_free_space:
          "Недостатньо вільного місця, видаліть непотрібні файли перш ніж продовжити",
        forbidden_filetype:
          "Розширення файлу не підтримується, список доступних розширень: .png, .svg, .webp, .pdf",
        invalid_syntax: "Даний синтаксис не підтримується",
        pin_invalid_syntax:
          "Невірний пін-код. Даний синтаксис не підтримується",
        file_in_use:
          "Неможливо видалити файл що в даний момент використовується",
        default_not_found: "Еквайрінг за замовчуванням вже встановлений",
        password_is_required: "Пароль є обов'язковим полем",
        can_not_edit: "Неможливо редагувати з статусом заблоковано",
        can_not_edit_parent:
          "Неможливо редагувати, батьківський елемент блоковано",
        is_not_avilable: "Вибраний елемент не доступний",
        invalid_date: "Невірний формат дати",
        missing_terms_agreement_confirm:
          "Підтвердження згоди з умовами публічної оферти є обов'язковим полем",
        async_job_not_found: "Асинхронне завдання не знайдено",
        plugin_inactive: "Плагін '%{resource}' не підключено",
        datex_error:
          "Не вдалося завантажити сторінку. Будь ласка, перевірте налаштування інтеграції мерчанта 'Датекс'",
        empty: "Не може бути пустим",
        empty_config:
          "Налаштуваня обраного Еквайрінгу не заповнені, будь ласка, оновіть налаштування",
        no_record: "Немає записів, що відповідають фільтрам",
      },
      success: "Зміни успішно збережено",
      no_available: "Ще немає '%{resource}'",
      confirm: {
        delete: "Ви впевнені, що хочете видалити цей елемент?",
      },
    },
  },
};

export default uk;
